import { LottieAssets } from '@/config/lottieAssets';
import { useLottie } from '@/utils/useLottie';

import styles from './LoadingDots.module.css';

/**
 * Перенос `lib/src/presentation/widgets/loading_dots.dart`.
 *
 * `Lottie.asset` без параметров сам крутит анимацию по кругу — здесь это
 * `autoplay` и `loop`. Обрезку по центру делает CSS-модуль.
 */
export function LoadingDots() {
  const { containerRef } = useLottie({
    animationData: LottieAssets.loading,
    autoplay: true,
    loop: true,
  });
  return <div ref={containerRef} className={styles.loadingDots} />;
}
